import React from "react";
import { Checkbox, CheckboxGroup } from "react-checkbox-group";
import ActiveIcon from "../vectors/ActiveIcon";
const photographer = require("../../styles/photographer.svg");

interface FilterByPhotographerProps {
  photographersList: {
    name: string;
    id: number;
    albumsCount: number;
  }[];
  selectedPhotographers: [];
  updateFilter: Function;
  expanded: boolean;
  collapseFilter: Function;
  isActive: boolean;
  pageConfig: {
    accentColor: string;
  };
  trackFilterEvents: (filterType: string) => void;
}

class FilterByPhotographer extends React.Component<FilterByPhotographerProps> {
  constructor(props: FilterByPhotographerProps) {
    super(props);
    this.selectionsChanged = this.selectionsChanged.bind(this);
  }

  selectionsChanged(newSelections: any) {
    this.props.updateFilter(newSelections);
    this.props.trackFilterEvents("photographer");
  }

  render() {
    return (
      <div className="panel panel-default">
        <div className="panel-heading" role="tab" id="headingFour">
          {this.props.isActive && (
            <div className="active-icon">
              <ActiveIcon color={this.props.pageConfig.accentColor} />
            </div>
          )}
          <img src={photographer} alt="" className="filter-icon" />
          <h4 className="panel-title">
            <a
              aria-expanded={this.props.expanded}
              className={`${this.props.expanded ? "" : "collapsed"}  ${
                this.props.isActive ? "active" : "inactive"
              }`}
              onClick={e => this.props.collapseFilter(e, "photographer")}
              role="button"
              data-toggle="collapse"
              data-parent="#filter-accordion"
              href="#collapseFour"
              aria-controls="collapseThree"
            >
              Photographer
            </a>
          </h4>
        </div>
        <div
          id="collapseFour"
          className={
            "panel-collapse collapse " + (this.props.expanded ? "in" : "")
          }
          role="tabpanel"
          aria-labelledby="headingThree"
        >
          <div className="panel-body">
            <ul className="check-radio checkmark">
              <CheckboxGroup
                name="selectedPhotographers"
                value={this.props.selectedPhotographers}
                onChange={this.selectionsChanged}
              >
                {this.props.photographersList.map((photographer: any) => (
                  <li key={photographer.id}>
                    <label>
                      <Checkbox value={photographer.id} />
                      <span className="r-dot" />
                      <span className="r-desc">
                        {photographer.name} ({photographer.albumsCount})
                      </span>
                    </label>
                  </li>
                ))}
              </CheckboxGroup>
            </ul>
          </div>
        </div>
      </div>
    );
  }
}

export default FilterByPhotographer;
